/**
 * Sentry (browser) — captura de erros no frontend.
 *
 * Ativa SOMENTE no cliente e SOMENTE se NEXT_PUBLIC_SENTRY_DSN estiver definido.
 * O import é dinâmico (code-split): o bundle do Sentry só é baixado quando há DSN.
 * Expõe `window.Sentry` para que a ErrorBoundary (que já chama
 * window.Sentry.captureException) reporte erros de render do React também.
 *
 * Setup em produção:
 *   1. Criar projeto "Browser/React" no Sentry e pegar o DSN público.
 *   2. Adicionar no .env do frontend: NEXT_PUBLIC_SENTRY_DSN=https://...
 *   3. Rebuild → erros do cliente passam a ser capturados.
 */
let started = false;

export function initSentry(): void {
  if (started || typeof window === "undefined") return;
  const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
  if (!dsn) return;
  started = true;

  import("@sentry/browser")
    .then((Sentry) => {
      Sentry.init({
        dsn,
        environment: process.env.NEXT_PUBLIC_APP_ENV || "production",
        release: process.env.NEXT_PUBLIC_SENTRY_RELEASE || undefined,
        tracesSampleRate: Number(process.env.NEXT_PUBLIC_SENTRY_TRACES || "0.1"),
        // Não enviar PII por padrão; ligue se o time decidir.
        sendDefaultPii: false,
      });
      // ErrorBoundary lê window.Sentry.captureException.
      (window as unknown as { Sentry?: unknown }).Sentry = Sentry;
    })
    .catch(() => {
      /* falha ao carregar o SDK não pode quebrar o app */
    });
}
